
export const imageFallback = './images/placeholder-image-300x225.png'